import React from 'react';
import classnames from 'classnames';
import OutOfOffice from '@fiverr-private/out_of_office';
import { logger } from '@fiverr-private/obs';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { useSellerVacation } from '../../hooks/useSellerVacation';
import { useIsSelfView } from '../../hooks/useIsSelfView';
import { useSellerData } from '../../hooks/useSellerData';
import { FederatedSeller } from '../../types';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the VacationMessageBanner Component');
    logger.error(err, {
        cause: originalError,
    });
};

interface VacationMessageBannerProps {
    sectionClassName?: string;
}

export const VacationMessageBanner = ({ sectionClassName }: VacationMessageBannerProps) => {
    const isCurrentUser = useIsSelfView();
    const { username, sellerId, displayName } = useSellerData(selectSellerSlice);
    const { isOnVacation, vacationMessage, vacationEndDate, vacationStartDate, isContactAllowed } = useSellerVacation();

    if (!isOnVacation) {
        return null;
    }

    const outOfOfficeProps = {
        username,
        user_id: sellerId,
        displayName,
        is_on_vacation: isOnVacation,
        start_date: vacationStartDate,
        end_date: vacationEndDate,
        message_for_buyer: vacationMessage,
        is_page_owner: isCurrentUser,
        allow_contact: isContactAllowed,
        vacation_status: isOnVacation ? 'active' : 'historic',
    };

    return (
        <ErrorBoundary onError={onRenderError}>
            <section className={classnames('m-b-40', sectionClassName)}>
                <OutOfOffice {...outOfOfficeProps} />
            </section>
        </ErrorBoundary>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        sellerId: seller.user.id,
        username: seller.user.name,
        displayName: seller.user.profile.displayName,
    };
}
